import { render } from "./ParcProfileDates.vue?vue&type=template&id=1a8ba313"
import script from "./ParcProfileDates.vue?vue&type=script&lang=js"
export * from "./ParcProfileDates.vue?vue&type=script&lang=js"

import "./ParcProfileDates.vue?vue&type=style&index=0&id=1a8ba313&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__